var map = {
	"./pic/badge/1.png": 64422,
	"./pic/badge/2.png": 5661,
	"./pic/badge/3.png": 84532,
	"./pic/badge/4.png": 30443,
	"./pic/badge/5.png": 9314,
	"./pic/badge/6.png": 57497,
	"./pic/badge/7.png": 76944,
	"./pic/badge/8.png": 27479,
	"./pic/badge/9.png": 84462,
	"./pic/city/1.png": 68330,
	"./pic/city/2.png": 9409,
	"./pic/city/3.png": 88280,
	"./pic/city/4.png": 10423,
	"./pic/city/5.png": 10926,
	"./pic/city/6.png": 38757,
	"./pic/city/7.png": 86492,
	"./pic/city/8-old.png": 87475,
	"./pic/city/8.png": 7883,
	"./pic/city/9.png": 17378,
	"./pic/encounter/old-grandfather.jpg": 7049,
	"./pic/items/bike.png": 13959,
	"./pic/items/bike_blue.png": 26616,
	"./pic/items/bike_green.png": 79339,
	"./pic/items/bike_red.png": 40107,
	"./pic/items/bike_yellow.png": 66932,
	"./pic/items/cap.png": 81310,
	"./pic/items/flashlight.png": 30470,
	"./pic/items/potion_full_heal.png": 14248,
	"./pic/items/potion_full_heal_endangered.png": 95794,
	"./pic/items/train_pass.png": 7270,
	"./pic/news/catch-button-glow.png": 53963,
	"./pic/news/dungeon-skill-used.png": 57663,
	"./pic/news/fight-report-redesign.png": 56992,
	"./pic/news/heal-lifesteal-preselect.png": 59001,
	"./pic/news/language-switcher.png": 97405,
	"./pic/news/notification-sound-catalog.png": 73846,
	"./pic/news/pokedex-caught-glow.png": 48820,
	"./pic/news/pokedex-redesign.png": 12349,
	"./pic/news/pokedex-type-filter.png": 48857,
	"./pic/news/pokemon-picker.png": 7793,
	"./pic/news/pvp-arena.png": 97079,
	"./pic/news/rules-mobile.png": 98115,
	"./pic/news/skill-dialog-header.png": 6585,
	"./pic/news/skills-table.png": 56854,
	"./pic/news/stadium-badge.png": 41304,
	"./pic/news/team-bottom-sheet-drag.png": 55625,
	"./pic/news/toplist-redesign.png": 56852,
	"./pic/news/trade-market-filters.png": 6122,
	"./pic/news/trainer-tab.png": 31390,
	"./pic/obstacles/Abyss.png": 71020,
	"./pic/obstacles/Boulder.png": 53995,
	"./pic/obstacles/Dark fog.png": 26266,
	"./pic/obstacles/Flaming wall.png": 82662,
	"./pic/obstacles/Ford.png": 65641,
	"./pic/obstacles/Low battery doors.png": 75042,
	"./pic/obstacles/Magic runes.png": 63098,
	"./pic/obstacles/Mysterious mist.png": 35609,
	"./pic/obstacles/Rapids.png": 85295,
	"./pic/obstacles/Thicket.png": 96128,
	"./pic/obstacles/Wooden roadblock.png": 95361,
	"./pic/pokemons/1.png": 99561,
	"./pic/pokemons/10.png": 97005,
	"./pic/pokemons/100.png": 39257,
	"./pic/pokemons/101.png": 23504,
	"./pic/pokemons/102.png": 88907,
	"./pic/pokemons/103.png": 25250,
	"./pic/pokemons/104.png": 34397,
	"./pic/pokemons/105.png": 96916,
	"./pic/pokemons/106.png": 35727,
	"./pic/pokemons/107.png": 50630,
	"./pic/pokemons/108.png": 90433,
	"./pic/pokemons/109.png": 17720,
	"./pic/pokemons/11.png": 70852,
	"./pic/pokemons/110.png": 36862,
	"./pic/pokemons/111.png": 89351,
	"./pic/pokemons/112.png": 86700,
	"./pic/pokemons/113.png": 22613,
	"./pic/pokemons/114.png": 98842,
	"./pic/pokemons/115.png": 46595,
	"./pic/pokemons/116.png": 9736,
	"./pic/pokemons/117.png": 3601,
	"./pic/pokemons/118.png": 42646,
	"./pic/pokemons/119.png": 39583,
	"./pic/pokemons/12.png": 84415,
	"./pic/pokemons/120.png": 559,
	"./pic/pokemons/121.png": 77894,
	"./pic/pokemons/122.png": 59101,
	"./pic/pokemons/123.png": 26068,
	"./pic/pokemons/124.png": 75979,
	"./pic/pokemons/125.png": 54850,
	"./pic/pokemons/126.png": 10937,
	"./pic/pokemons/127.png": 4688,
	"./pic/pokemons/128.png": 24599,
	"./pic/pokemons/129.png": 79022,
	"./pic/pokemons/13.png": 6326,
	"./pic/pokemons/130.png": 44484,
	"./pic/pokemons/131.png": 24077,
	"./pic/pokemons/132.png": 92310,
	"./pic/pokemons/133.png": 46111,
	"./pic/pokemons/134.png": 18080,
	"./pic/pokemons/135.png": 42281,
	"./pic/pokemons/136.png": 94098,
	"./pic/pokemons/137.png": 99291,
	"./pic/pokemons/138.png": 11628,
	"./pic/pokemons/139.png": 23253,
	"./pic/pokemons/14.png": 80585,
	"./pic/pokemons/140.png": 55949,
	"./pic/pokemons/141.png": 29796,
	"./pic/pokemons/142.png": 43359,
	"./pic/pokemons/143.png": 65270,
	"./pic/pokemons/144.png": 39529,
	"./pic/pokemons/145.png": 84704,
	"./pic/pokemons/146.png": 39739,
	"./pic/pokemons/147.png": 74386,
	"./pic/pokemons/148.png": 26389,
	"./pic/pokemons/149.png": 43500,
	"./pic/pokemons/15.png": 25760,
	"./pic/pokemons/150.png": 45186,
	"./pic/pokemons/16.png": 80795,
	"./pic/pokemons/17.png": 15442,
	"./pic/pokemons/18.png": 67445,
	"./pic/pokemons/19.png": 84556,
	"./pic/pokemons/2.png": 34418,
	"./pic/pokemons/20.png": 75112,
	"./pic/pokemons/21.png": 89329,
	"./pic/pokemons/22.png": 59162,
	"./pic/pokemons/23.png": 60387,
	"./pic/pokemons/24.png": 46572,
	"./pic/pokemons/25.png": 15669,
	"./pic/pokemons/26.png": 48318,
	"./pic/pokemons/27.png": 66631,
	"./pic/pokemons/28.png": 6048,
	"./pic/pokemons/29.png": 77225,
	"./pic/pokemons/3.png": 83419,
	"./pic/pokemons/30.png": 56307,
	"./pic/pokemons/31.png": 40746,
	"./pic/pokemons/32.png": 81825,
	"./pic/pokemons/33.png": 60696,
	"./pic/pokemons/34.png": 5220,
	"./pic/pokemons/35.png": 83342,
	"./pic/pokemons/36.png": 11173,
	"./pic/pokemons/37.png": 58908,
	"./pic/pokemons/38.png": 80299,
	"./pic/pokemons/39.png": 89794,
	"./pic/pokemons/4.png": 89828,
	"./pic/pokemons/40.png": 77918,
	"./pic/pokemons/41.png": 30407,
	"./pic/pokemons/42.png": 11404,
	"./pic/pokemons/43.png": 63669,
	"./pic/pokemons/44.png": 39898,
	"./pic/pokemons/45.png": 87651,
	"./pic/pokemons/46.png": 50792,
	"./pic/pokemons/47.png": 44657,
	"./pic/pokemons/48.png": 67350,
	"./pic/pokemons/49.png": 80639,
	"./pic/pokemons/5.png": 15981,
	"./pic/pokemons/50.png": 80313,
	"./pic/pokemons/51.png": 64560,
	"./pic/pokemons/52.png": 29963,
	"./pic/pokemons/53.png": 66306,
	"./pic/pokemons/54.png": 81482,
	"./pic/pokemons/55.png": 37972,
	"./pic/pokemons/56.png": 60431,
	"./pic/pokemons/57.png": 91686,
	"./pic/pokemons/58.png": 31489,
	"./pic/pokemons/59.png": 58776,
	"./pic/pokemons/6.png": 25302,
	"./pic/pokemons/60.png": 85540,
	"./pic/pokemons/61.png": 48781,
	"./pic/pokemons/62.png": 33366,
	"./pic/pokemons/63.png": 87167,
	"./pic/pokemons/64.png": 59136,
	"./pic/pokemons/65.png": 83337,
	"./pic/pokemons/66.png": 18802,
	"./pic/pokemons/67.png": 40347,
	"./pic/pokemons/68.png": 36332,
	"./pic/pokemons/69.png": 47957,
	"./pic/pokemons/7.png": 3391,
	"./pic/pokemons/70.png": 41615,
	"./pic/pokemons/71.png": 2598,
	"./pic/pokemons/72.png": 157,
	"./pic/pokemons/73.png": 67124,
	"./pic/pokemons/74.png": 17035,
	"./pic/pokemons/75.png": 95906,
	"./pic/pokemons/76.png": 51993,
	"./pic/pokemons/77.png": 45744,
	"./pic/pokemons/78.png": 65655,
	"./pic/pokemons/79.png": 20078,
	"./pic/pokemons/8.png": 96840,
	"./pic/pokemons/80.png": 76570,
	"./pic/pokemons/81.png": 66403,
	"./pic/pokemons/82.png": 4424,
	"./pic/pokemons/83.png": 52817,
	"./pic/pokemons/84.png": 8254,
	"./pic/pokemons/85.png": 84039,
	"./pic/pokemons/86.png": 17004,
	"./pic/pokemons/87.png": 28629,
	"./pic/pokemons/88.png": 99474,
	"./pic/pokemons/89.png": 21019,
	"./pic/pokemons/9.png": 36785,
	"./pic/pokemons/90.png": 71109,
	"./pic/pokemons/91.png": 88220,
	"./pic/pokemons/92.png": 46327,
	"./pic/pokemons/93.png": 750,
	"./pic/pokemons/94.png": 18465,
	"./pic/pokemons/95.png": 97336,
	"./pic/pokemons/96.png": 43091,
	"./pic/pokemons/97.png": 4234,
	"./pic/pokemons/98.png": 80829,
	"./pic/pokemons/99.png": 47796,
	"./pic/pokemons/Alolan/1.png": 39017,
	"./pic/pokemons/Alolan/10.png": 59501,
	"./pic/pokemons/Alolan/100.png": 37817,
	"./pic/pokemons/Alolan/101.png": 31568,
	"./pic/pokemons/Alolan/102.png": 61739,
	"./pic/pokemons/Alolan/103.png": 71234,
	"./pic/pokemons/Alolan/104.png": 32957,
	"./pic/pokemons/Alolan/105.png": 95476,
	"./pic/pokemons/Alolan/106.png": 16943,
	"./pic/pokemons/Alolan/107.png": 35398,
	"./pic/pokemons/Alolan/108.png": 63265,
	"./pic/pokemons/Alolan/109.png": 42136,
	"./pic/pokemons/Alolan/109a.png": 81091,
	"./pic/pokemons/Alolan/109b.png": 95816,
	"./pic/pokemons/Alolan/109c.png": 93681,
	"./pic/pokemons/Alolan/10a.png": 38432,
	"./pic/pokemons/Alolan/11.png": 96260,
	"./pic/pokemons/Alolan/110.png": 13406,
	"./pic/pokemons/Alolan/110a.png": 10261,
	"./pic/pokemons/Alolan/110b.png": 24510,
	"./pic/pokemons/Alolan/110c.png": 76999,
	"./pic/pokemons/Alolan/111.png": 31719,
	"./pic/pokemons/Alolan/112.png": 11660,
	"./pic/pokemons/Alolan/113.png": 80757,
	"./pic/pokemons/Alolan/114.png": 24250,
	"./pic/pokemons/Alolan/115.png": 41827,
	"./pic/pokemons/Alolan/115a.png": 4786,
	"./pic/pokemons/Alolan/116.png": 56552,
	"./pic/pokemons/Alolan/117.png": 54417,
	"./pic/pokemons/Alolan/118.png": 42486,
	"./pic/pokemons/Alolan/119.png": 38815,
	"./pic/pokemons/Alolan/11a.png": 62583,
	"./pic/pokemons/Alolan/12.png": 81535,
	"./pic/pokemons/Alolan/120.png": 41871,
	"./pic/pokemons/Alolan/120a.png": 93126,
	"./pic/pokemons/Alolan/121.png": 73126,
	"./pic/pokemons/Alolan/121a.png": 15661,
	"./pic/pokemons/Alolan/122.png": 40541,
	"./pic/pokemons/Alolan/123.png": 19412,
	"./pic/pokemons/Alolan/123a.png": 84615,
	"./pic/pokemons/Alolan/124.png": 11403,
	"./pic/pokemons/Alolan/125.png": 47746,
	"./pic/pokemons/Alolan/126.png": 61753,
	"./pic/pokemons/Alolan/127.png": 46000,
	"./pic/pokemons/Alolan/128.png": 19831,
	"./pic/pokemons/Alolan/129.png": 29838,
	"./pic/pokemons/Alolan/129a.png": 43589,
	"./pic/pokemons/Alolan/129b.png": 71790,
	"./pic/pokemons/Alolan/12a.png": 99734,
	"./pic/pokemons/Alolan/12b.png": 81357,
	"./pic/pokemons/Alolan/13.png": 44086,
	"./pic/pokemons/Alolan/130.png": 8868,
	"./pic/pokemons/Alolan/130a.png": 16695,
	"./pic/pokemons/Alolan/130b.png": 9116,
	"./pic/pokemons/Alolan/131.png": 62765,
	"./pic/pokemons/Alolan/131a.png": 30912,
	"./pic/pokemons/Alolan/132.png": 48790,
	"./pic/pokemons/Alolan/137.png": 72731,
	"./pic/pokemons/Alolan/14.png": 94057,
	"./pic/pokemons/Alolan/143.png": 88790,
	"./pic/pokemons/Alolan/143a.png": 9181,
	"./pic/pokemons/Alolan/15.png": 69856,
	"./pic/pokemons/Alolan/16.png": 51067,
	"./pic/pokemons/Alolan/17.png": 29522,
	"./pic/pokemons/Alolan/18.png": 58677,
	"./pic/pokemons/Alolan/19.png": 47052,
	"./pic/pokemons/Alolan/2.png": 90834,
	"./pic/pokemons/Alolan/20.png": 45832,
	"./pic/pokemons/Alolan/21.png": 85777,
	"./pic/pokemons/Alolan/22.png": 61114,
	"./pic/pokemons/Alolan/23.png": 82691,
	"./pic/pokemons/Alolan/23a.png": 19346,
	"./pic/pokemons/Alolan/24.png": 52524,
	"./pic/pokemons/Alolan/24a.png": 65807,
	"./pic/pokemons/Alolan/25.png": 35413,
	"./pic/pokemons/Alolan/26.png": 49662,
	"./pic/pokemons/Alolan/27.png": 20999,
	"./pic/pokemons/Alolan/28.png": 93728,
	"./pic/pokemons/Alolan/29.png": 48553,
	"./pic/pokemons/Alolan/3.png": 12379,
	"./pic/pokemons/Alolan/30.png": 21363,
	"./pic/pokemons/Alolan/31.png": 66154,
	"./pic/pokemons/Alolan/32.png": 15137,
	"./pic/pokemons/Alolan/33.png": 30520,
	"./pic/pokemons/Alolan/34.png": 22039,
	"./pic/pokemons/Alolan/35.png": 56641,
	"./pic/pokemons/Alolan/36.png": 50821,
	"./pic/pokemons/Alolan/37.png": 21404,
	"./pic/pokemons/Alolan/37a.png": 11039,
	"./pic/pokemons/Alolan/38.png": 25003,
	"./pic/pokemons/Alolan/38a.png": 33226,
	"./pic/pokemons/Alolan/39.png": 3874,
	"./pic/pokemons/Alolan/39a.png": 48657,
	"./pic/pokemons/Alolan/4.png": 57572,
	"./pic/pokemons/Alolan/40.png": 68702,
	"./pic/pokemons/Alolan/40a.png": 25429,
	"./pic/pokemons/Alolan/41.png": 87015,
	"./pic/pokemons/Alolan/42.png": 50604,
	"./pic/pokemons/Alolan/43.png": 36053,
	"./pic/pokemons/Alolan/44.png": 79546,
	"./pic/pokemons/Alolan/45.png": 80771,
	"./pic/pokemons/Alolan/46.png": 95496,
	"./pic/pokemons/Alolan/47.png": 9713,
	"./pic/pokemons/Alolan/48.png": 81430,
	"./pic/pokemons/Alolan/49.png": 77759,
	"./pic/pokemons/Alolan/5.png": 20813,
	"./pic/pokemons/Alolan/50.png": 93113,
	"./pic/pokemons/Alolan/51.png": 86864,
	"./pic/pokemons/Alolan/52.png": 683,
	"./pic/pokemons/Alolan/53.png": 10178,
	"./pic/pokemons/Alolan/53a.png": 75313,
	"./pic/pokemons/Alolan/54.png": 71901,
	"./pic/pokemons/Alolan/54a.png": 53744,
	"./pic/pokemons/Alolan/55.png": 50772,
	"./pic/pokemons/Alolan/55a.png": 82215,
	"./pic/pokemons/Alolan/56.png": 55887,
	"./pic/pokemons/Alolan/57.png": 90694,
	"./pic/pokemons/Alolan/58.png": 2209,
	"./pic/pokemons/Alolan/58a.png": 25372,
	"./pic/pokemons/Alolan/58b.png": 26007,
	"./pic/pokemons/Alolan/59.png": 81080,
	"./pic/pokemons/Alolan/59a.png": 79907,
	"./pic/pokemons/Alolan/59b.png": 94632,
	"./pic/pokemons/Alolan/6.png": 89046,
	"./pic/pokemons/Alolan/60.png": 47812,
	"./pic/pokemons/Alolan/60a.png": 31863,
	"./pic/pokemons/Alolan/61.png": 18061,
	"./pic/pokemons/Alolan/61a.png": 29728,
	"./pic/pokemons/Alolan/62.png": 87734,
	"./pic/pokemons/Alolan/62a.png": 50877,
	"./pic/pokemons/Alolan/63.png": 1023,
	"./pic/pokemons/Alolan/64.png": 49696,
	"./pic/pokemons/Alolan/65.png": 27817,
	"./pic/pokemons/Alolan/66.png": 96850,
	"./pic/pokemons/Alolan/67.png": 28027,
	"./pic/pokemons/Alolan/68.png": 31788,
	"./pic/pokemons/Alolan/69.png": 84053,
	"./pic/pokemons/Alolan/7.png": 42847,
	"./pic/pokemons/Alolan/70.png": 80815,
	"./pic/pokemons/Alolan/71.png": 12070,
	"./pic/pokemons/Alolan/72.png": 79485,
	"./pic/pokemons/Alolan/73.png": 58356,
	"./pic/pokemons/Alolan/74.png": 50347,
	"./pic/pokemons/Alolan/75.png": 86690,
	"./pic/pokemons/Alolan/76.png": 697,
	"./pic/pokemons/Alolan/77.png": 84944,
	"./pic/pokemons/Alolan/77a.png": 8619,
	"./pic/pokemons/Alolan/78.png": 58775,
	"./pic/pokemons/Alolan/78a.png": 85054,
	"./pic/pokemons/Alolan/79.png": 85134,
	"./pic/pokemons/Alolan/8.png": 95784,
	"./pic/pokemons/Alolan/80.png": 24602,
	"./pic/pokemons/Alolan/81.png": 88707,
	"./pic/pokemons/Alolan/82.png": 51848,
	"./pic/pokemons/Alolan/83.png": 45713,
	"./pic/pokemons/Alolan/84.png": 78974,
	"./pic/pokemons/Alolan/85.png": 31463,
	"./pic/pokemons/Alolan/86.png": 12460,
	"./pic/pokemons/Alolan/87.png": 64725,
	"./pic/pokemons/Alolan/88.png": 77522,
	"./pic/pokemons/Alolan/89.png": 8699,
	"./pic/pokemons/Alolan/9.png": 27825,
	"./pic/pokemons/Alolan/90.png": 68229,
	"./pic/pokemons/Alolan/91.png": 50716,
	"./pic/pokemons/Alolan/92.png": 39447,
	"./pic/pokemons/Alolan/93.png": 65806,
	"./pic/pokemons/Alolan/94.png": 32545,
	"./pic/pokemons/Alolan/95.png": 59832,
	"./pic/pokemons/Alolan/96.png": 34323,
	"./pic/pokemons/Alolan/96a.png": 3938,
	"./pic/pokemons/Alolan/97.png": 83562,
	"./pic/pokemons/Alolan/97a.png": 99785,
	"./pic/pokemons/Alolan/98.png": 60157,
	"./pic/pokemons/Alolan/99.png": 39028,
	"./pic/pokemons/Alolan/99a.png": 59655,
	"./pic/position/DUNGEON.png": 86865,
	"./pic/position/DUNGEON_WIN.png": 40426,
	"./pic/position/DUNGEON_WIN3.png": 48395,
	"./pic/position/FIGHT.png": 6477,
	"./pic/position/FIGHT_BIOMS/WILD_CAVE.png": 3999,
	"./pic/position/FIGHT_BIOMS/WILD_FACTORY.png": 99936,
	"./pic/position/FIGHT_BIOMS/WILD_FOREST.png": 84455,
	"./pic/position/FIGHT_BIOMS/WILD_MOUNTAINS.png": 28798,
	"./pic/position/FIGHT_BIOMS/WILD_NEUTRAL.png": 143,
	"./pic/position/FIGHT_BIOMS/WILD_PLAINS.png": 20339,
	"./pic/position/FIGHT_BIOMS/WILD_RIVER.png": 52964,
	"./pic/position/FIGHT_BIOMS/WILD_RUINS.png": 93067,
	"./pic/position/FIGHT_BIOMS/WILD_SEA.png": 81731,
	"./pic/position/FIGHT_BIOMS/WILD_TROPIC.png": 10203,
	"./pic/position/FIGHT_BIOMS/WILD_VULCAN.png": 17561,
	"./pic/position/FIGHT_TRAINER.png": 73975,
	"./pic/position/FIGHT_TRAINER_WIN.png": 82772,
	"./pic/position/LEAGUE_FIGHT-old.png": 75895,
	"./pic/position/LEAGUE_FIGHT.png": 88751,
	"./pic/position/MEWTWO_FIGHT.png": 75321,
	"./pic/position/MEWTWO_FIGHT_QIN.png": 44536,
	"./pic/position/OBSTACLE_FIGHT.png": 76571,
	"./pic/position/START.png": 17203,
	"./pic/position/TEAM_ROCKET.png": 72305,
	"./pic/position/TRAINER_FIGHT_WILD.png": 22616,
	"./pic/position/WILD_TROPIC2.png": 40325,
	"./pic/position/thumb/DUNGEON.png": 74648,
	"./pic/pvp/battlefield-forest.jpg": 91478,
	"./pic/pvp/battlefield-pvp-liga.jpg": 57911,
	"./pic/rank/rank-1.png": 41606,
	"./pic/rank/rank-2.png": 82845,
	"./pic/rank/rank-3.png": 45364,
	"./pic/rank/rank-4.png": 7627,
	"./pic/rank/rank-5.png": 86498,
	"./pic/rank/rank-6.png": 34681,
	"./pic/rank/rank-7.png": 37776,
	"./pic/rank/rank-8.png": 88311,
	"./pic/roads/1.png": 60658,
	"./pic/roads/2.png": 75273,
	"./pic/roads/3.png": 97152,
	"./pic/roads/4.png": 48479,
	"./pic/roads/5.png": 51542,
	"./pic/roads/6.png": 65517,
	"./pic/roads/7.png": 11620,
	"./pic/roads/8.png": 55491,
	"./pic/roads/9.png": 7738,
	"./pic/roads/komprimovane/1.png": 72529,
	"./pic/roads/komprimovane/2.png": 51418,
	"./pic/roads/komprimovane/3.png": 15523,
	"./pic/roads/komprimovane/4.png": 39276,
	"./pic/roads/komprimovane/5.png": 91541,
	"./pic/roads/komprimovane/6.png": 5790,
	"./pic/roads/komprimovane/7.png": 58279,
	"./pic/roads/komprimovane/8.png": 57184,
	"./pic/roads/komprimovane/9.png": 35305,
	"./pic/rules/badges.png": 14219,
	"./pic/rules/screenshot-obstacle.png": 23653,
	"./pic/rules/screenshot-pokedex.png": 20054,
	"./pic/rules/screenshot-trainer.png": 61899,
	"./pic/stadion/1.png": 46171,
	"./pic/stadion/2.png": 67840,
	"./pic/stadion/3.png": 22665,
	"./pic/stadion/4.png": 22838,
	"./pic/stadion/5.png": 19167,
	"./pic/stadion/6.png": 64516,
	"./pic/stadion/7.png": 4461,
	"./pic/stadion/8.png": 4602,
	"./pic/stadion/gyms/1.png": 5012,
	"./pic/stadion/gyms/2.png": 23919,
	"./pic/stadion/gyms/3.png": 1254,
	"./pic/stadion/gyms/4.png": 94329,
	"./pic/stadion/gyms/5.png": 97424,
	"./pic/stadion/gyms/6.png": 50923,
	"./pic/stadion/gyms/7.png": 29794,
	"./pic/stadion/gyms/8.png": 76741,
	"./pic/stones/BUG.png": 97834,
	"./pic/stones/DARK.png": 89774,
	"./pic/stones/DRAGON.png": 65171,
	"./pic/stones/ELECTRIC.png": 18775,
	"./pic/stones/FIGHTING.png": 32952,
	"./pic/stones/FIRE.png": 96138,
	"./pic/stones/FLYING.png": 87007,
	"./pic/stones/GHOST.png": 60445,
	"./pic/stones/GRASS.png": 37850,
	"./pic/stones/GROUND.png": 84499,
	"./pic/stones/ICE.png": 34725,
	"./pic/stones/NORMAL.png": 58899,
	"./pic/stones/POISON.png": 46618,
	"./pic/stones/PSYCHIC.png": 29169,
	"./pic/stones/ROCK.png": 63913,
	"./pic/stones/STEEL.png": 32289,
	"./pic/stones/ULTIMATE.png": 67707,
	"./pic/stones/WATER.png": 89441,
	"./pic/trainer/1.png": 67908,
	"./pic/trainer/2.png": 53183,
	"./pic/trainer/3.png": 99382,
	"./pic/trainer/4.png": 65705,
	"./pic/trainer/5.png": 41504,
	"./pic/trainer/6.png": 22715,
	"./pic/trainer/7.png": 1170,
	"./pic/trainer/8.png": 30325,
	"./pic/trainer/9.png": 18700,
	"./pic/trainer/Amber.png": 1288,
	"./pic/trainer/Apn.png": 26498,
	"./pic/trainer/Ash Ketchum.png": 38922,
	"./pic/trainer/Babli.png": 44091,
	"./pic/trainer/Bianca.png": 23703,
	"./pic/trainer/Black.png": 66920,
	"./pic/trainer/Bob.png": 59592,
	"./pic/trainer/Borek.png": 24148,
	"./pic/trainer/Brian.png": 2309,
	"./pic/trainer/Broruto.png": 30466,
	"./pic/trainer/Calem.png": 81635,
	"./pic/trainer/Calus.png": 97677,
	"./pic/trainer/Carmen.png": 68979,
	"./pic/trainer/Cinciri.png": 13208,
	"./pic/trainer/Clemont.png": 78897,
	"./pic/trainer/Cody.png": 29454,
	"./pic/trainer/Dawn.png": 89563,
	"./pic/trainer/Diana.png": 55836,
	"./pic/trainer/Ethan.png": 86161,
	"./pic/trainer/Ferguson.png": 3108,
	"./pic/trainer/Fines.png": 43302,
	"./pic/trainer/Fleur.png": 45331,
	"./pic/trainer/Frostylina.png": 21400,
	"./pic/trainer/Fuflin.png": 6105,
	"./pic/trainer/Gerta.png": 18502,
	"./pic/trainer/Ginger.png": 25529,
	"./pic/trainer/Gladion.png": 25961,
	"./pic/trainer/Gloria.png": 36389,
	"./pic/trainer/Gotsu.png": 19111,
	"./pic/trainer/Hector.png": 72942,
	"./pic/trainer/Hilbert.png": 54899,
	"./pic/trainer/Hilda.png": 74131,
	"./pic/trainer/Jezz.png": 15450,
	"./pic/trainer/Jimmy.png": 76835,
	"./pic/trainer/Jonathan.png": 19662,
	"./pic/trainer/Ketchy.png": 27903,
	"./pic/trainer/Kris.png": 34690,
	"./pic/trainer/Kyra.png": 50506,
	"./pic/trainer/Lana.png": 25107,
	"./pic/trainer/Leaf.png": 90253,
	"./pic/trainer/Lillie.png": 74674,
	"./pic/trainer/Lucas.png": 52797,
	"./pic/trainer/Lyra.png": 33135,
	"./pic/trainer/Mallow.png": 57153,
	"./pic/trainer/Mangetino.png": 31365,
	"./pic/trainer/May.png": 6666,
	"./pic/trainer/Methan.png": 53190,
	"./pic/trainer/Metsu.png": 13535,
	"./pic/trainer/Moon.png": 70898,
	"./pic/trainer/Nadja.png": 74207,
	"./pic/trainer/Nate.png": 40123,
	"./pic/trainer/Patricia.png": 61804,
	"./pic/trainer/Polly.png": 86301,
	"./pic/trainer/Pomi.png": 18748,
	"./pic/trainer/Prophan.png": 60025,
	"./pic/trainer/Pupin.png": 4215,
	"./pic/trainer/Red.png": 20348,
	"./pic/trainer/Ringo.png": 57760,
	"./pic/trainer/Rosa.png": 92620,
	"./pic/trainer/Saffire.png": 77907,
	"./pic/trainer/Serena.png": 89885,
	"./pic/trainer/Sky.png": 10374,
	"./pic/trainer/Summer.png": 67706,
	"./pic/trainer/Sussy.png": 39278,
	"./pic/trainer/Trin.png": 97586,
	"./pic/trainer/Volty.png": 81303,
	"./pic/trainer/Yam.png": 90218,
	"./pic/trainer/Zu.png": 85146,
	"./pic/trainer/league/Adiha.png": 57494,
	"./pic/trainer/league/Agent Smith.png": 78377,
	"./pic/trainer/league/Alex.png": 22403,
	"./pic/trainer/league/Anton.png": 2479,
	"./pic/trainer/league/Beilin.png": 6330,
	"./pic/trainer/league/Bizika.png": 32151,
	"./pic/trainer/league/Blizzy.png": 27071,
	"./pic/trainer/league/Boban.png": 53851,
	"./pic/trainer/league/Bred.png": 28652,
	"./pic/trainer/league/Bubla.png": 28005,
	"./pic/trainer/league/Colora.png": 51141,
	"./pic/trainer/league/Davison.png": 87045,
	"./pic/trainer/league/Derik.png": 15414,
	"./pic/trainer/league/Donovan.png": 20446,
	"./pic/trainer/league/Dony.png": 10367,
	"./pic/trainer/league/Dr. Raven.png": 15645,
	"./pic/trainer/league/Edudant.png": 63768,
	"./pic/trainer/league/Fan Zang.png": 656,
	"./pic/trainer/league/Farmer Tom.png": 49206,
	"./pic/trainer/league/Francimore.png": 39949,
	"./pic/trainer/league/Fykis.png": 83405,
	"./pic/trainer/league/Gejedli.png": 66099,
	"./pic/trainer/league/Ghost Henry.png": 55468,
	"./pic/trainer/league/Giruga.png": 88956,
	"./pic/trainer/league/Gorogo.png": 90390,
	"./pic/trainer/league/Graundy.png": 76195,
	"./pic/trainer/league/Ha Jajan.png": 20720,
	"./pic/trainer/league/Hala.png": 4567,
	"./pic/trainer/league/Heidy.png": 77584,
	"./pic/trainer/league/Helico.png": 9293,
	"./pic/trainer/league/Hontenten.png": 74926,
	"./pic/trainer/league/Hó Fušihó.png": 38004,
	"./pic/trainer/league/Izaak.png": 99053,
	"./pic/trainer/league/Jeager.png": 5001,
	"./pic/trainer/league/Kahid.png": 22196,
	"./pic/trainer/league/Kelvin.png": 41468,
	"./pic/trainer/league/Kemil.png": 85441,
	"./pic/trainer/league/Kevin.png": 23952,
	"./pic/trainer/league/Lemerd.png": 15722,
	"./pic/trainer/league/Lemred.png": 62368,
	"./pic/trainer/league/Lenore.png": 71272,
	"./pic/trainer/league/Lulan.png": 30913,
	"./pic/trainer/league/Mindezeen.png": 68212,
	"./pic/trainer/league/Mindireen.png": 91000,
	"./pic/trainer/league/Mr. Gardenier.png": 30035,
	"./pic/trainer/league/Nemo.png": 21340,
	"./pic/trainer/league/Olaf.png": 70971,
	"./pic/trainer/league/Olda.png": 32711,
	"./pic/trainer/league/Piny.png": 44709,
	"./pic/trainer/league/Pof. Jožko.png": 66479,
	"./pic/trainer/league/Rebeca.png": 59079,
	"./pic/trainer/league/Red Baron.png": 73282,
	"./pic/trainer/league/Rowan.png": 75930,
	"./pic/trainer/league/Rubla.png": 68981,
	"./pic/trainer/league/Shadow.png": 80559,
	"./pic/trainer/league/Silver.png": 48232,
	"./pic/trainer/league/Sir Marquis.png": 49271,
	"./pic/trainer/league/Swift.png": 96370,
	"./pic/trainer/league/Tentanten.png": 112,
	"./pic/trainer/league/Tentari.png": 78084,
	"./pic/trainer/league/Tyson.png": 75516,
	"./pic/trainer/league/Walter.png": 29618,
	"./pic/trainer/league/Weird Bob.png": 30809,
	"./pic/trainer/league/Zabu.png": 13459,
	"./pic/trainer/league/Činčiro.png": 67029,
	"./pic/trainer/players/default0.png": 64785,
	"./pic/trainer/players/default1.png": 70920,
	"./pic/trainer/players/default10.png": 39130,
	"./pic/trainer/players/default11.png": 56707,
	"./pic/trainer/players/default12.png": 55080,
	"./pic/trainer/players/default13.png": 69297,
	"./pic/trainer/players/default14.png": 28286,
	"./pic/trainer/players/default15.png": 46599,
	"./pic/trainer/players/default16.png": 26540,
	"./pic/trainer/players/default17.png": 95637,
	"./pic/trainer/players/default18.png": 66482,
	"./pic/trainer/players/default19.png": 64347,
	"./pic/trainer/players/default2.png": 7779,
	"./pic/trainer/players/default20.png": 9931,
	"./pic/trainer/players/default21.png": 46274,
	"./pic/trainer/players/default22.png": 60281,
	"./pic/trainer/players/default23.png": 44528,
	"./pic/trainer/players/default24.png": 40399,
	"./pic/trainer/players/default25.png": 71654,
	"./pic/trainer/players/default26.png": 55421,
	"./pic/trainer/players/default27.png": 17940,
	"./pic/trainer/players/default28.png": 13235,
	"./pic/trainer/players/default29.png": 62474,
	"./pic/trainer/players/default3.png": 60026,
	"./pic/trainer/players/default30.png": 9280,
	"./pic/trainer/players/default31.png": 87401,
	"./pic/trainer/players/default32.png": 72786,
	"./pic/trainer/players/default33.png": 87611,
	"./pic/trainer/players/default34.png": 23748,
	"./pic/trainer/players/default35.png": 77645,
	"./pic/trainer/players/default36.png": 47318,
	"./pic/trainer/players/default37.png": 60607,
	"./pic/trainer/players/default38.png": 30760,
	"./pic/trainer/players/default39.png": 24625,
	"./pic/trainer/players/default4.png": 83797,
	"./pic/trainer/players/default40.png": 55025,
	"./pic/trainer/players/default41.png": 15080,
	"./pic/trainer/players/default42.png": 51939,
	"./pic/trainer/players/default43.png": 46714,
	"./pic/trainer/players/default44.png": 4661,
	"./pic/trainer/players/default45.png": 21772,
	"./pic/trainer/players/default46.png": 6599,
	"./pic/trainer/players/default47.png": 18910,
	"./pic/trainer/players/default48.png": 17801,
	"./pic/trainer/players/default5.png": 47884,
	"./pic/trainer/players/default6.png": 50535,
	"./pic/trainer/players/default7.png": 98046,
	"./pic/trainer/players/default8.png": 27561,
	"./pic/trainer/players/default9.png": 49440,
	"./pic/trainer/teamRocket/Archer.png": 53894,
	"./pic/trainer/teamRocket/Ariana.png": 82219,
	"./pic/trainer/teamRocket/Butch.png": 8959,
	"./pic/trainer/teamRocket/Cassidy.png": 59129,
	"./pic/trainer/teamRocket/James.png": 45239,
	"./pic/trainer/teamRocket/Jessie.png": 32268,
	"./pic/trainer/teamRocket/Meowth.png": 69131,
	"./pic/trainer/teamRocket/Orm.png": 69907,
	"./pic/trainer/teamRocket/Petrel.png": 74051,
	"./pic/trainer/teamRocket/Proton.png": 76243,
	"./pic/undefined.jpg": 25871,
	"./pic/undefined.png": 49919,
	"./pic/web/Meowth_portret.png": 32477,
	"./pic/web/Officer_Jenny.png": 90971,
	"./pic/web/Officer_Jenny_avatar.png": 68775,
	"./pic/web/boty.gif": 74577,
	"./pic/web/brock_suspicious.png": 35883,
	"./pic/web/call_oak.png": 68368,
	"./pic/web/day.png": 44326,
	"./pic/web/footprints.png": 86226,
	"./pic/web/forest.png": 67977,
	"./pic/web/gym.png": 68793,
	"./pic/web/heal-lifesteal.gif": 61103,
	"./pic/web/hit-impact.gif": 51711,
	"./pic/web/league_stadion.png": 45188,
	"./pic/web/lose.png": 16337,
	"./pic/web/masterball.png": 42251,
	"./pic/web/mewtwo.png": 43327,
	"./pic/web/mewtwo_chalenge.png": 13419,
	"./pic/web/mirror-pok.png": 20870,
	"./pic/web/nurse-joy-heal-frozen.png": 4652,
	"./pic/web/nurse-joy-heal.gif": 65012,
	"./pic/web/oak.png": 89711,
	"./pic/web/oak_avatar.png": 56555,
	"./pic/web/oak_teaching.png": 70285,
	"./pic/web/oaks_house.png": 78233,
	"./pic/web/options_hint.png": 99464,
	"./pic/web/pierce-pok.png": 47651,
	"./pic/web/poison-drops.gif": 31432,
	"./pic/web/pokeball.png": 48882,
	"./pic/web/pokeball_catching.gif": 61227,
	"./pic/web/pokeball_choose.png": 32676,
	"./pic/web/pokeball_leave.png": 44946,
	"./pic/web/pokecenter.png": 61158,
	"./pic/web/registration.png": 87545,
	"./pic/web/registration_joy.png": 12134,
	"./pic/web/road.png": 1456,
	"./pic/web/road2.png": 81472,
	"./pic/web/shield-pok.png": 62184,
	"./pic/web/stunned.gif": 60082,
	"./pic/web/thumb/league_stadion.png": 80043,
	"./pic/web/travel/nurse-joy.png": 10177,
	"./pic/web/travel/ship-station.png": 19194,
	"./pic/web/travel/train-station-city.png": 93012,
	"./pic/web/travel/train-station-town.png": 24301,
	"./pic/web/trophy.png": 84108,
	"./pic/web/vs_swords.png": 10410,
	"./pic/web/wild.png": 87398,
	"./pic/web/win.png": 1666,
	"./pic/wild/CAVE.png": 29583,
	"./pic/wild/CAVE2.png": 65261,
	"./pic/wild/DUNGEON.png": 29952,
	"./pic/wild/FACTORY.png": 15184,
	"./pic/wild/FOREST.png": 59319,
	"./pic/wild/MOUNTAINS.png": 83726,
	"./pic/wild/NEUTRAL.png": 1887,
	"./pic/wild/PLAINS.png": 41635,
	"./pic/wild/RIVER.png": 25684,
	"./pic/wild/RUINS.png": 72571,
	"./pic/wild/SEA.png": 4563,
	"./pic/wild/TROPIC.png": 84971,
	"./pic/wild/VULCAN.png": 30249,
	"./pic/wild/thumb/CAVE.png": 39044,
	"./pic/wild/thumb/CAVE2.png": 99564,
	"./pic/wild/thumb/DUNGEON.png": 60981,
	"./pic/wild/thumb/FACTORY.png": 55073,
	"./pic/wild/thumb/FOREST.png": 88512,
	"./pic/wild/thumb/MOUNTAINS.png": 99963,
	"./pic/wild/thumb/NEUTRAL.png": 15742,
	"./pic/wild/thumb/PLAINS.png": 2956,
	"./pic/wild/thumb/RIVER.png": 88277,
	"./pic/wild/thumb/RUINS.png": 17266,
	"./pic/wild/thumb/SEA.png": 51854,
	"./pic/wild/thumb/TROPIC.png": 79092,
	"./pic/wild/thumb/VULCAN.png": 44766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17384;